import React, { FC, LazyExoticComponent } from 'react';
import { Route, Routes } from 'react-router-dom';

import { NotFoundPage } from '../../app/notFoundPage/notFoundPage.component';
import { CheckAuthLayout } from '../../components';
import { RouteWithComponent } from '../../interfaces';

import { provisionsRoutes } from './provisions.routes';

const Provisions: React.FC = (): JSX.Element => (
  <Routes>
    <Route element={<CheckAuthLayout />}>
      {provisionsRoutes.map((route: RouteWithComponent): JSX.Element[] =>
        Object.values(route.pathSettings.urls).map((url: string, index: number): JSX.Element => {
          const Component: LazyExoticComponent<FC> = route.component;

          return (
            <Route
              element={<Component />}
              // eslint-disable-next-line react/no-array-index-key
              key={`${url}-${index}`}
              path={url}
            />
          );
        })
      )}
    </Route>
    <Route element={<NotFoundPage />} path="*" />
  </Routes>
);

export default Provisions;
